import FiledCheckbox from "./FieldCheckbox";

export default FiledCheckbox;